/* eslint-disable no-unused-vars */
import axios from '../../utils/axios-wrapper';
import Cache, { keysList } from '../../utils/cache';
import { API_ORIGIN } from '../../config';

export default {
  get(id, config) {
    return axios
      .get(`${API_ORIGIN}/v2/companies${id ? `/${id}` : ''}`, config)
      .then((res) => {
        Cache.set(keysList.company, res.data);
        return res.data;
      });
  },

  update(id, config) {
    Cache.remove(keysList.company);
    // Clear the user cache since we load the company
    // object sometimes from user.company
    Cache.remove(keysList.user);
    return axios
      .patch(`${API_ORIGIN}/v2/companies/${id}`, config)
      .then((res) => res.data);
  },
};
